<script setup>
import { ref, defineProps, defineEmits } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import lang from './lang2x.vue'
import { useI18n } from 'vue-i18n'
import { useIndexStore } from '@/store'
import { showToast } from 'vant'
import logo from '@/assets/icon/public/logo.png'
import { formatEthereumAddress } from '@/utils'
import centerRoutes from '@/router/modules/center'
import MenuIcon from './menuIcon.vue'
// console.log(centerRoutes);

const emit = defineEmits(['connectWallet'])
defineProps({
  theme: {
    type: String,
    default: 'light' //'dark' // light
  }
})
const { t } = useI18n()
const store = useIndexStore()
let langRef = ref(null)
let show = ref(false)
const openOrCloseEnd = ref(false)
const router = useRouter()
const route = useRoute()

let handleLanguge = () => {
  langRef.value.open()
}
let connectWallet = () => {
  emit('connectWallet')
}
let navList = ref([])

let meunList = centerRoutes.filter((item) => item.meta.isMeun)
meunList = meunList.map((item) => {
  return {
    titleKey: item.meta.titleKey,
    path: item.path,
    icon: item.meta.icon
  }
})
navList.value.push(...meunList)
// console.log(meunList);


const changeMeun = () => {
  show.value = !show.value
}
const handleClick = (item) => {
  if (item.path === '/exchange') {
    showToast('coming soon~')
    return
  }
  if (route.path !== item.path) {
    router.push({ path: item.path })
  }
  changeMeun()
}
const toHome = () => {
  router.push({ path: '/index' })
  show.value = false
}
// 关闭结束
const handleClosed = () => {
  openOrCloseEnd.value = false
}
// 打开结束
const handleOpened = () => {
  openOrCloseEnd.value = true
}
</script>
<template>
  <nav :class="[showTips && !show ? 'mb-66' : '']">
    <div class="flex justify-between items-center w-100%">
      <div class="flex items-center justify-center">
        <div>
          <img src="/src/assets/icon/header/header1.png" class="w-154px h-52px van-haptics-feedback" @click="toHome" />
        </div>
        <div class="w-2px h-52px bg-#90AEA2 mx-26px"></div>
        <div>
          <img src="/src/assets/icon/header/header2.png" class="w-226px h-68px van-haptics-feedback" @click="toHome" />
        </div>
      </div>
      <div class="flex items-center min-w-200px border-1px border-solid border-#90AEA2 rounded-18px py-14px px-10px">
        <img src="/src/assets/icon/header/card.png" class="w-32px h-30px van-haptics-feedback" />
        <div class="ml-18px">
          <div v-if="!store.address" class="text-[22px] text-[#09322A] font-roboto font-400 van-haptics-feedback"
            @click="connectWallet">
            链接钱包
          </div>
          <div v-else class="flex flex-col">
            <div class="text-[22px] text-[#09322A] font-roboto font-400 van-haptics-feedback">
              {{ formatEthereumAddress(store.address) }}
            </div>
            <div class="flex items-center mt-12px">
              <div class="w-10px h-10px rounded-full bg-#07823A"></div>
              <span class="ml-10px text-22px text-#323232">已连接</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
  <lang ref="langRef" />
  <van-popup v-model:show="show" z-index="9" :overlay="false" position="left" @closed="handleClosed"
    @opened="handleOpened">
    <div class="nav_body">
      <div class="nav_list">
        <div class="nav_list_item" :class="{ 'is-active': route.path === item.path }" v-for="item in navList"
          :key="item.titleKey" @click="handleClick(item)">
          <div class="nav_list_item--left flex items-center gap-24">
            <MenuIcon v-if="item.icon" :name="item.icon" class="nav-menu-icon" />
            <div class="nav_list_item--label">{{ $t(item.titleKey) }}</div>
          </div>
          <div class="nav_list_item--icon flex items-center justify-center h-100%">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 32 32" fill="none">
              <path d="M18.1826 16L8 6.66625L10.9087 4L24 16L10.9087 28L8 25.3338L18.1826 16Z" fill="#9DABC4" />
            </svg>
          </div>
        </div>
      </div>
      <!-- <div class="links flex items-center gap-38 pl-20px mt-78px">
        <div v-for="(link, index) in links" :key="index">
          <a :href="link.link">
            <van-image width="30" height="30" :src="link.icon"></van-image>
          </a>
        </div>
      </div> -->
    </div>
  </van-popup>
</template>

<style scoped lang="scss">
nav {
  position: relative !important;
  // top: 0;
  // left: 0;
  width: 100%;
  height: 146px;
  padding: 44px 30px;
  background-color: transparent;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 99;
  background-color: #F9F7EB;
  // background: var(--Linear, linear-gradient(0deg, #02070B -2.14%, #000B85 57.2%, #326EFF 101.57%));
  backdrop-filter: blur(10px);
  // margin-bottom: 66px;
}

.right {
  // position: absolute;
  // right: 0;
  // top: 0;
  // height: 100%;
  // border-radius: 0 0 0 5555px;
  // background: #FFF;
  // // padding-top: 20px;
  // padding-right: 18px;
  // // height: 48px;
}

.account {
  color: #000;
  text-align: center;
  font-family: MiSans;
  font-size: 12px;
  font-style: normal;
  font-weight: 630;
  line-height: normal;
  margin-left: 12px;
  margin-right: 20px;
}

.nav_btn {
  margin-left: 16px;
}

.nav_body {
  width: 100vw;
  height: 100vh;
  margin-top: auto;
  background: radial-gradient(89.43% 47.97% at 50.13% 100%, #3e509c 0%, #03002c 62.5%);
  // background: #fff;
  // padding-top: calc(var(--van-nav-bar-height) + 44px);
  padding-top: calc(146px + 60px);
}

.nav_list {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 56px;

  .nav_list_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 20px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:active {
      opacity: 0.7;
      transform: scale(0.98);
    }

    .nav_list_item--left {
      display: flex;
      align-items: center;
    }

    .nav-menu-icon {
      width: 36px;
      height: 36px;
      color: #9DABC4;
      transition: color 0.3s ease;
    }

    .nav_list_item--label {
      color: #fff;
      font-family: MiSans;
      font-size: 36px;
      font-style: normal;
      font-weight: 520;
      line-height: normal;
      transition: color 0.3s ease;
    }

    .nav_list_item--icon {
      margin-left: 10px;
      transition: transform 0.3s ease;

      svg path {
        transition: fill 0.3s ease;
      }
    }

    // 激活狀態
    &.is-active {
      .nav-menu-icon {
        color: #326EFF;
      }

      .nav_list_item--label {
        color: #326EFF;
      }

      .nav_list_item--icon svg path {
        fill: #326EFF;
      }
    }

    &:hover {
      .nav_list_item--icon {
        transform: translateX(4px);
      }
    }
  }
}

.border-c18 {
  border: 1px solid #00c18d;
}
</style>
